import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DynamicObject } from "../models/General";
import Navbar from "../components/Navbar/Navbar";
import Status from "../components/Status/Status";
import useHttp from "../Hooks/use-http/use-http";
import { useNavigate, useParams } from "react-router";
import { AxiosError, AxiosResponse } from "axios";
import {
  configGetPaymentFailedStatusApi,
  configGetPaymentStatusApi,
} from "../Api/api.config";
import { getLang, getUrlBasedOnCountry, mustache } from "../Helpers/functions";
import { FaRedoAlt, FaUndoAlt } from "react-icons/fa";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";
import style from "../components/Status/Status.module.css";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import i18n from "../i18n";
import PaymentInfoItem from "../components/Cart/PaymentInfoItem/PaymentInfoItem";
import { useTranslation } from "react-i18next";

const CartBundleUseFinalize = ({message}) => {
  let navigate = useNavigate();
  console.log("message", message);


  /*-----------------------------
   *           STATES
   * ----------------------------*/
  const { t } = useTranslation();

  /*-----------------------------
   *   REQUEST API ON SUCCESS BUTTON
   *            HANDLER
   * ----------------------------*/
  const onClickSuccessHandler = useCallback(() => {
    if (message?.referrer) window.location.href = message.referrer;
  }, [message]);

  const closeUrl = useMemo(
    function () {
      return (
        message?.referrer ||
        getUrlBasedOnCountry(
          localStorage.getItem("countryCode") ?? "jo",
          getLang()
        )
      );
    },
    [message]
  );

  const onClickHandler = () => {
    onClickSuccessHandler();
  };

  return (
    <div>
      {message && (
        <Navbar
          title={""}
          subTitle={""}
          referral_url={closeUrl}
          cancel={true}
          loading={false}
        />
      )}
      {
        <div
          dir={i18n.language == "en" ? "ltr" : "rtl"}
          className={style.container}
        >
          <div className={style.row}>
            {message.success ? (
              <AiOutlineCheckCircle
                className={`${style.color_success} ${style.huge_icon}`}
              ></AiOutlineCheckCircle>
            ) : (
              <AiOutlineCloseCircle
                className={`${style.color_fail} ${style.huge_icon}`}
              ></AiOutlineCloseCircle>
            )}
          </div>
          <div className={`${style.row} mb-1`}>
            <h1
              className={`${style.no_pad} ${style.bold} ${style.font_size_md}`}
            >
              {message?.title ?? ""}
            </h1>
          </div>
            <div className={style.row}>
              <p
                className={`${style.text_align_center} ${style.font_size_sm} mb-0`}
              >
                {message?.description ?? ""}
              </p>
            </div>
            {/* <div className={`${style.payment_info_container_style} mt-3 mb-2 `}> */}
                {/* <PaymentInfoItem
                    label={t('order.no')}
                    value={cartId}
                    type={'bold'}
                    cardId={true}
                    extra='copy'
                    isTotal={false}

                /> */}
            {/* </div> */}
          <div className={`row ${style.button_container}`}>
            <button className={`${style.btn}`} onClick={onClickHandler}>
              <div className={`row`}>
                <div className={`col-12`}>
                  <div className={`${style.buttonTitle}`}>
                    {" "}
                    {message.success ? t("returnBack") : t("pleaseTryAgain")}
                  </div>
                  <span
                    className={`${
                      i18n.language == "en" ? `float-end` : "float-start"
                    } `}
                  >
                    <div className={`${style.iconContainer}`}>
                      {" "}
                      {message.success ? (
                        i18n.language == "en" ? (
                          <IoArrowForward />
                        ) : (
                          <IoArrowBack />
                        )
                      ) : i18n.language == "en" ? (
                        <FaRedoAlt />
                      ) : (
                        <FaUndoAlt />
                      )}
                    </div>
                  </span>
                </div>
              </div>
            </button>
          </div>
        </div>
      }
    </div>
  );
};

export default CartBundleUseFinalize;
